<template lang="pug">
.custom-registration-wrapper(data-cy='custom-registration')
  AcademySignup(v-if='isSachkundeCompany')
  OtherAcademiesSignup(v-else)
</template>

<script setup lang="ts">
  import { onMounted } from 'vue'

  import useCommonMixin from '@/composables/useCommonMixin'
  import OtherAcademiesSignup from '@/components/signup/OtherAcademiesSignup.vue'
  import AcademySignup from '@/components/signup/AcademySignup.vue'

  const { isSachkundeCompany, scrollToTop } = useCommonMixin()

  onMounted(() => {
    scrollToTop()
  })
</script>

<style lang="postcss"></style>
